"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));
var _currency = require("@nerdwallet/currency");
var _utils = require("./lib/utils");
var _marketplaceProductCardModule = _interopRequireDefault(require("./marketplace-product-card.module.css"));
var Qualifications = function Qualifications(_ref) {
  var bullets = _ref.bullets,
    feesBullets = _ref.feesBullets,
    termLengths = _ref.termLengths,
    disclaimer = _ref.disclaimer;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !(0, _isEmpty2.default)(bullets) && /*#__PURE__*/_react.default.createElement("div", {
    className: _marketplaceProductCardModule.default.contentSection
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    bold: true
  }, "Qualifications"), /*#__PURE__*/_react.default.createElement(_currency.List, null, (0, _map2.default)(bullets, function (qualification) {
    return /*#__PURE__*/_react.default.createElement(_currency.Li, {
      key: qualification
    }, (0, _utils.sanitizeNode)(qualification));
  }))), termLengths && /*#__PURE__*/_react.default.createElement("div", {
    className: _marketplaceProductCardModule.default.contentSection
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    bold: true
  }, "Available Term Lengths"), /*#__PURE__*/_react.default.createElement(_currency.List, null, /*#__PURE__*/_react.default.createElement(_currency.Li, null, (0, _utils.sanitizeNode)(termLengths)))), !(0, _isEmpty2.default)(feesBullets) && /*#__PURE__*/_react.default.createElement("div", {
    className: _marketplaceProductCardModule.default.contentSection
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    bold: true
  }, "Fees"), /*#__PURE__*/_react.default.createElement(_currency.List, null, (0, _map2.default)(feesBullets, function (fee) {
    return /*#__PURE__*/_react.default.createElement(_currency.Li, {
      key: fee
    }, (0, _utils.sanitizeNode)(fee));
  }))), disclaimer && /*#__PURE__*/_react.default.createElement("div", {
    className: _marketplaceProductCardModule.default.contentSection
  }, /*#__PURE__*/_react.default.createElement(_currency.Type, {
    className: (0, _classes.default)('type-0')
  }, "Disclaimer: ", (0, _utils.sanitizeNode)(disclaimer))));
};
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');
  Qualifications.propTypes = {
    bullets: PropTypes.arrayOf(PropTypes.node),
    disclaimer: PropTypes.string,
    feesBullets: PropTypes.arrayOf(PropTypes.node),
    termLengths: PropTypes.string
  };
}
Qualifications.defaultProps = {
  bullets: [],
  disclaimer: '',
  feesBullets: [],
  termLengths: ''
};
var _default = Qualifications;
exports.default = _default;